import React, { useState } from 'react';
import { Select, SelectItem, Button, Input } from '@nextui-org/react';
import { FaSearch } from 'react-icons/fa';
import { AiOutlinePlus } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import JoinProjectModal from '../JoinProjectModal';

export default function ProjectTopBar(){
  const [isJoinModalOpen, setIsJoinModalOpen] = useState(false);
    
  const list = [
    { value: 1, label: 'Aktif Proje' },
    { value: 2, label: 'Pasif Proje' },
    { value: 3, label: 'Tamamlanan Proje' }
  ]

    return(
      <>
        <div className="flex flex-row items-center justify-between ">
        <div className="relative ">
          <Input
            type="email"
            label={'Proje Ara...'}
            labelPlacement={'inside'}
            classNames={{
              inputWrapper: ['bg-white', 'dark:bg-dark-300', 'focus:bg-white', 'hover:bg-white', 'dark:hover:bg-dark-300', '!cursor-text', 'border-gray-300', 'dark:border-gray-600'],
              input: ['text-gray-900', 'dark:text-white'],
              label: ['text-gray-700', 'dark:text-gray-300']
            }}
          />
          <FaSearch className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 dark:text-gray-500" />
        </div>

        <div className="flex justify-end  mt-3  flex-row items-center">
          <div className="hidden md:block">
            <Select 
              items={list} 
              label="Durum Seçiniz" 
              placeholder="Güncel Durum" 
              className="w-[200px]" 
              color="primary"
              classNames={{
                trigger: "bg-white dark:bg-dark-300 border-gray-300 dark:border-gray-600",
                value: "text-gray-900 dark:text-white",
                label: "text-gray-700 dark:text-gray-300",
                placeholder: "text-gray-500 dark:text-gray-400"
              }}
            >
              {(list) => <SelectItem key={list.value}>{list.label}</SelectItem>}
            </Select>
          </div>
          <div className="ml-2">
            <Button as={Link} to="/projects/create" title="Oluştur" className="dark:bg-[#7375E1] bg-[#da402f] text-white text-sm h-12 w-full px-10">
              <AiOutlinePlus className="absolute left-4 top-4 text-white text-sm" />
              <p>Oluştur</p>
            </Button>
          </div>
          <div className="ml-2">
            <Button 
              onClick={() => setIsJoinModalOpen(true)}
              title="Katıl" 
              className="bg-[#039be5] dark:bg-[#0889C9] text-white text-sm h-12 w-full px-10"
            >
              <FaSearch className="absolute left-4 top-4 text-white opacity-60 text-sm" />
              <p> Katıl</p>
            </Button>
          </div>
        </div>
      </div>
      
      {/* Join Project Modal */}
      <JoinProjectModal 
        isOpen={isJoinModalOpen} 
        onClose={() => setIsJoinModalOpen(false)} 
      />
    </>
  )
}